/* AUTO ASSIGNEES */
Vue.component('auto_assignees', {
    template:'#autoassignees-template',

    data:function(){
        return{
            assignees: [],
            users: [],
            activeUserId: -1
        };
    },
    created:function(){

        activeInstance = this;

        showLoadingOverlay();
        axios.get(baseURL+'/ajax/auto_assignees/list').then(function(response) {
            $('body').LoadingOverlay("hide");

            activeInstance.assignees = response.data;
        });


        axios.get(baseURL+'/api/users/active').then(function (response) {
            activeInstance.users = response.data;
        }).catch(function (error) {
            console.log(error);
        });
    },
    methods:{
        filterUsers: function(arr) {
            var new_arr = arr.filter(function(val) {
                console.log(val);
                var isset = true;
                for(var i = 0, i_l = activeInstance.assignees.length; i < i_l; i ++) {
                    if (activeInstance.assignees[i].user.id == val.id) {
                        isset = false;
                        break;
                    }
                }
                return isset;
            });

            return new_arr;
        },
        addUser: function() {
            bootbox.confirm("Biztosan hozzáadod a felhasználót?", function(result){
                if (result) {
                    axios.post(baseURL + '/ajax/auto_assignees/add', {user_id: activeInstance.activeUserId}).then(function(response) {
                        activeInstance.activeUserId = -1;
                        activeInstance.assignees.push(response.data);
                    }).catch(function(error) {
                        console.log(error);
                    });
                }
            });
        },
        removeUser: function(id, index) {
            bootbox.confirm("Biztosan eltávolítod a felhasználót?", function(result){
                if (result) {
                    axios.post(baseURL + '/ajax/auto_assignees/remove', {id: id}).then(function(response) {
                        activeInstance.assignees.splice(index, 1);
                    }).catch(function(error) {
                        console.log(error);
                    });
                }
            });
        },
        edit:function(division) {
            bootbox.prompt({
                title: division.name + " - tevékenység módosítása",
                value: division.name,
                callback: function(result) {
                    if (result) {
                        axios.post(baseURL + '/admin/division/update', {id: division.id, name: result, enabled: 1}).then(function(response) {
                            division.name = result;
                        }).catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            });
        }
    }
});